import { useEffect, useState } from "react";
import CompanyServices from "../services/CompanyServices";
import { Button } from "antd";

const PickVademecum = ({ onClickVademecum, values }) => {
  const [listOfVademecum, setListOfVademecum] = useState([]);

  useEffect(() => {
    fetchVademecumList();
  }, []);

  const fetchVademecumList = async () => {
    try {
      const response = await CompanyServices.getAllVademecum();
      setListOfVademecum(response.data.vademecums);
    } catch (error) {
      console.error("Error fetching vademecum list:", error);
    }
  };

  return (
    <div>
      <p>Clickea el Vademecum que quieres vincular</p>

      {listOfVademecum?.map((vademecum, index) => {
        const isSelected = values?.vademecum?.includes(vademecum.id);

        return (
          <Button
            type={isSelected ? "primary" : "default"}
            key={index}
            onClick={() => onClickVademecum(vademecum.id)}
            className="my-2 mr-2 rounded-lg px-4 cursor-pointer text-center"
          >
            {vademecum.name}
          </Button>
        );
      })}
    </div>
  );
};

export default PickVademecum;
